module.exports = __webpack_public_path__ + "img/captcha_magento.c49184d7.svg";